import { colors } from '@pff-consumer/core-ui'
import { CurrentProgressState } from '@pff-consumer/schema'
import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'
import { Icon } from '../../atoms/icon'
import { Text, TextDescriptionVariant } from '../../atoms/text'
import { useStyles } from './status-pane.web.styles'
import type { StatusPaneProps } from './status-pane.props'
import { Button } from '../../atoms/button/button'

export const StatusPane = (props: StatusPaneProps) => {
  const { children, header, message, state, actionText, actionTestId = 'status-pane-action-button', onAction } = props
  const styles = useStyles()
  const iconStyle = state === CurrentProgressState.IN_PROGRESS ? `${styles.spinStyle}` : ''
  const showActionButton = actionText && onAction

  return (
    <div
      className={styles.container}
      data-testid='status-pane-container'
      key={state}
    >
      <div className={iconStyle}>
        <Icon
          group={SVGGroup.Icons}
          testID='fantasySync.progressState.icon'
          name={state}
          width='100'
          height='100'
        />
      </div>
      <Text
        variant={TextDescriptionVariant.TEXT_MD_XBOLD}
        textAlign='center'
      >
        {header}
      </Text>
      {message && (
        <Text
          variant={TextDescriptionVariant.TEXT_BASE_REGULAR}
          colorOverride={colors.webTextColorLight}
          textAlign='center'
        >
          {message}
        </Text>
      )}
      {showActionButton && (
        <div className={styles.button}>
          <Button
            testID={actionTestId}
            title={actionText}
            size='sm'
            onPress={onAction}
            accessibilityLabel={`${actionText} Action Button`}
          />
        </div>
      )}
      {children}
    </div>
  )
}
